var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PopupState from "material-ui-popup-state";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import { bindMenu, bindTrigger } from "material-ui-popup-state/hooks";
import { MenuItem } from "@mui/material";
import { getReimbursementByMember, headCells, tableHeaders } from "./handler";
import StyleTableBodyWrapper from "./style";
import { useCommonLoader } from "../Loader";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { getComparator, stableSort } from "../EnhancedTableHead/handlers";
import ResponsiveMRR from "./ResponsiveMRR";
const rows = [
    createData("600016", "2020-04-20", "VITALCARE FP LLC", 670, 43, "FINAL"),
];
function createData(no, date_of_service, provider, charged, paid, status) {
    return { no, date_of_service, provider, charged, paid, status };
}
export function MyReimbursement(props) {
    var _a;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [loader, setLoader] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { setLoading, unSetLoading } = useCommonLoader();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("service_date");
    const [selected, setSelected] = React.useState([]);
    React.useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading();
            setLoader(true);
            const response = yield getReimbursementByMember();
            setData(response);
            setLoader(false);
            unSetLoading();
        }
        catch (error) {
            setLoader(false);
            unSetLoading();
        }
    });
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    // const updateSelectedRow = () => {
    //   setselectedReference(null);
    // try {
    //   const findIndexToUpdate = data.findIndex((oldRow: any, index: number) => {
    //     console.log("updatedRow.id, oldRow.id:::: ", oldRow, oldRow.id, index);
    //     return updatedRow.id === oldRow.id;
    //   });
    //   setData((prevData) => {
    //     const clonePrevData: any = [...prevData];
    //     clonePrevData[findIndexToUpdate] = updatedRow;
    //     return clonePrevData;
    //   });
    //   console.log("{ ...updatedRow }::: ", { ...updatedRow });
    // } catch (error) {
    //   console.error(error);
    //   console.log("updateSelectedRow error::: ", error);
    // }
    // };
    const actionHandler = useCallback((rowData) => {
        return () => {
            props.onCallback(rowData);
        };
    }, []);
    if (loader)
        return (React.createElement(StyleTableBodyWrapper, null));
    if (!data.length) {
        return (React.createElement(StyleTableBodyWrapper, null,
            React.createElement("p", { className: "noneeds_msg_display" }, "You haven't submitted any reimbursement requests yet. Click the button below to submit one.")));
    }
    if (isSmallScreen) {
        return (React.createElement(React.Fragment, null, data.map((row) => (React.createElement(ResponsiveMRR, { actionHandler: actionHandler, row: row })))));
    }
    return (React.createElement(StyleTableBodyWrapper, { sx: { width: "100%" } },
        React.createElement(TableContainer, { sx: { maxHeight: 440, width: "100%" } },
            React.createElement(Table, { stickyHeader: true, "aria-label": "sticky table" },
                React.createElement(EnhancedTableHead, { numSelected: selected.length, order: order, orderBy: orderBy, onSelectAllClick: handleSelectAllClick, onRequestSort: handleRequestSort, rowCount: rows.length, headCells: headCells }),
                React.createElement(TableBody, null,
                    loader ? React.createElement("p", null, " Fetching Data...") : null,
                    loader || !data.length
                        ? null
                        :
                            (_a = stableSort(data, getComparator(order, orderBy))) === null || _a === void 0 ? void 0 : _a.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (React.createElement(TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: row.id }, Object.keys(tableHeaders).map((column) => {
                                    const value = row[column];
                                    return (React.createElement(React.Fragment, null, column !== "action" ? (React.createElement(TableCell, { key: row[value], className: `table-${column} table-${row.className[row.id + column]}` },
                                        React.createElement("span", null, value))) : (React.createElement(UpdatePopup, { update: actionHandler(row) }))));
                                })));
                            })))),
        React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 100], component: "div", count: data.length, rowsPerPage: rowsPerPage, sx: {
                ".Mui-disabled": {
                    backgroundColor: "transparent !important",
                    color: "rgba(0, 0, 0, 0.26) !important",
                },
            }, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })));
}
export const UpdatePopup = (props) => {
    const updateHandler = useCallback(() => {
        props.update();
    }, []);
    return (React.createElement(TableCell, { align: "left", className: "rowTableCell" },
        React.createElement(PopupState, { variant: "popover", popupId: "demo-popup-menu" }, (popupState) => (React.createElement(React.Fragment, null,
            React.createElement(IconButton, Object.assign({ disableRipple: true, sx: { position: "inherit" } }, bindTrigger(popupState)),
                React.createElement(MoreVertIcon, null)),
            React.createElement(Menu, Object.assign({}, bindMenu(popupState), { onClick: popupState.close, anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                }, transformOrigin: {
                    vertical: -10,
                    horizontal: 30,
                } }),
                React.createElement(MenuItem, { onClick: updateHandler }, "Update")))))));
};
